import { z } from "zod";

// `message` is a translation KEY, not a translated string. The server returns
// the key and the client resolves it through `t(...)`. Keeps the server
// locale-agnostic — mirrors membersClubForm / footer.newsletter.
export const customerServiceSchema = z.object({
	email: z
		.string()
		.min(1, { message: "customerService.fieldError.emailRequired" })
		.email({ message: "customerService.fieldError.emailInvalid" }),
	topic: z.string().min(1, { message: "customerService.fieldError.topicRequired" }),
	message: z.string().trim().min(1, { message: "customerService.fieldError.messageRequired" }),
	consent: z.literal(true, { message: "customerService.fieldError.consentRequired" }),
});

export type CustomerServiceInput = z.infer<typeof customerServiceSchema>;
